import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import useCart from '../hooks/useCart'
import Button from '../components/ui/Button'
export default function ProductDetail() {
    const {
        state: {
            product: { id, image, name, description, price, options }
        },
    } = useLocation()
    const { addOrUpdateItem } = useCart()
    const [success, setSuccess] = useState()
    const [selected, setSelected] = useState(options && options[0])
    const handleSelect = (e) => {
        setSelected(e.target.value)
    }
    const handleClick = (e) => {

        const product = {
            id, image, name, price, options: selected,
            quantity: 1,
        }

        addOrUpdateItem.mutate(
            product,
            {
                onSuccess: () => {
                    setSuccess('Product was added to the cart successfully.')
                    setTimeout(() => {
                        setSuccess(null)
                    }, 3000)
                }
            }
        )
    }
    return (
        <>
            <p className='mx-12 mt-4 text-gray-700'></p>
            <section class='flex flex-col md:flex-row p-4'>
                <img className='w-full px-4 basis-4/12' src={image} alt={name} />
                <div className='w-full basis-5/12 flex flex-col p-4'>
                    <h2 className='text-3xl font-bold py-2'>{name}</h2>
                    <p className='text-2xl font-bold border-b border-gray-400'>${price}</p>
                    <p className='py-4 text-lg'>{description}</p>
                    <div className='flex items-center'>
                        <label className='text-brand font-bold' htmlFor='select'>Options: </label>
                        <select
                            id='select'
                            className='p-2 m-4 flex-1 border-2 border-dashed border-brand outline-none'
                            onChange={handleSelect}
                            value={selected}
                        >
                            {options && options.map((value, index) =>
                                <option key={index} value={value} >
                                    {value}
                                </option>
                            )}
                        </select>
                    </div>
                    {success && <p className='my-2'>{success}</p>}
                    <Button text='Add to Cart' onClick={handleClick} />
                </div>
            </section>
        </ >
    )
}
